<template>
  <v-expand-transition out-in>    
    <v-container v-if="!app.merkato.show">
            <v-layout justify-center="" >
                <v-flex md4 sm6 xs8 class="pa-4">
                  <v-layout justify-center="">
                    <v-btn v-if="!app.merkato.load" :disabled="(app.contract.hasChange || !app.contract.valid)" rounded block :color="app.color" @click="initializeMerkato()" >Document bewerken</v-btn>

                    <core-loader v-if="app.merkato.load"></core-loader>
                    
                    </v-layout>
                </v-flex>
            </v-layout>

      </v-container>
  </v-expand-transition>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState(["app", "contract"])
  },
  methods: {
    ...mapActions(["initializeMerkato"])
  }
};
</script>